<template>
  <div>
    <transition name="upload-progress-fade">
      <div class="upload-progress">
        <div class="upload-mask"></div>
        <div class="status-progress-inner">
          <div class="title-progress">
            <div class="title">{{ titleText }}</div>
            <div class="progress">
              <el-progress
                  :percentage="percentage"
                  :status="status"
                  :show-text="false"
                  :stroke-width="5"
              />
            </div>
          </div>
          <el-button class="btn" type="danger" plain @click="cancel">{{ btnLabel }}</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "UploadProgress",
  props: {
    title: {
      type: String,
      default: "Uploading"
    }
  },
  data() {
    return {
      titleText: this.title,
      visible: false,
      percentage: 0,
      status: "success",
      btnLabel: "Cancel"
    }
  },
  watch: {
    title(value) {
      this.titleText = value;
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.percentage = 0;
      this.$set(this, "status", "success");
    },
    success() {
      this.$set(this, "status", "success");
      this.$set(this, "btnLabel", "Close");
    },
    fail() {
      this.$set(this, "status", "exception");
      this.$set(this, "btnLabel", "Close");
    },
    setPercentage(percentage) {
      this.$set(this, "percentage", percentage);
    },
    setTitle(title) {
      this.$set(this, "title", title);
    },
    cancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.close();
    },
    close() {
      this.visible = false;
      setTimeout(() => {
        this.percentage = 0;
        this.success();
        this.$destroy();
        document.body.removeChild(this.$el);
      }, 300);
    }
  }
}
</script>

<style lang="scss" scoped>

.upload-progress {
  z-index: 99998;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .upload-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .status-progress-inner {
    z-index: 1;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
    box-sizing: border-box;
    background-color: #fff;
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    .title-progress {
      margin-right: 10px;

      .progress {
        margin-top: 10px;
        width: 300px;
      }
    }
  }

  .btn {
    width: 70px;
  }
}

.upload-progress-fade-enter-active {
  -webkit-animation: upload-progress-fade-in 0.3s;
  animation: upload-progress-fade-in 0.3s;
}

.upload-progress-fade-leave-active {
  -webkit-animation: upload-progress-fade-out 0.3s;
  animation: upload-progress-fade-out 0.3s;
}

@-webkit-keyframes upload-progress-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes upload-progress-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes upload-progress-fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes upload-progress-fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
